export default "__VITE_ASSET__cff722b4__"